<template>
  <Modal
    v-model:is-open="isActive"
    class="invoice"
    size="is-medium"
    :header="header"
    :is-disabled="loading"
    :save-disabled="!billData.charge"
    button-label="Agregar"
    @save="onSubmit"
    @cancel="closeModal"
  >
    <form ref="form">
      <div class="columns mb-1">
        <Field
          v-model="billData.charge"
          v-maska="bindedObject"
          class="column mb-0 has-addons-left"
          placeholder="Ingresar"
          label="Monto:"
          required
          data-maska="N.##"
          data-maska-tokens="N:[0-9]:multiple"
          :disabled="loading"
        >
          <template #addonsLeft>
            <div class="monto-addon has-addons-right">$</div>
          </template>
        </Field>
        <div class="column">
          <Field
            v-model="billData.folio"
            class="mb-0"
            maxlength="15"
            text-transform="upper"
            placeholder="Ingresar folio"
            label="Folio:"
            :disabled="loading"
          />
        </div>
      </div>
      <Field
        v-model="billData.description"
        label="Descripción de la factura:"
        type="textarea"
        maxlength="100"
        placeholder="Descripción"
        :disabled="loading"
      />
      <p class="ml-auto counter-field mt-1">{{ descriptionLenght }}</p>
    </form>
  </Modal>
</template>
<script setup>
// Imports
import { computed, defineModel, reactive, watch } from 'vue';
import { Modal, Field } from '@/components';

// Component Options

// Props and Emits
const props = defineProps({
  clientId: { type: String, default: '' },
  data: { type: Object, default: () => ({}) },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(['createInvoice', 'update:active', 'closeModal']);
const isActive = defineModel('active', { type: Boolean, default: false });

const bindedObject = reactive({});
const billData = reactive({
  charge: '',
  folio: '',
  description: '',
  isEdit: false,
});

// Composition API Helpers

// Reactive Variables

// Computed Properties
const header = computed(() => (props.data.id ? 'Editar factura' : 'Añadir factura'));
const descriptionLenght = computed(() => `${billData.description?.length ?? 0} / 100`);

// Watchers
watch(
  () => props.data,
  (newData) => {
    if (!newData) return;
    if (newData.charge !== undefined) billData.charge = newData.charge;
    if (newData.folio !== undefined) billData.folio = newData.folio;
    if (newData.description !== undefined) billData.description = newData.description;
    if (newData.id !== undefined) billData.isEdit = !!newData.id;
  },
  { immediate: true, deep: false },
);

// Lifecycle Hooks

// Methods
const onSubmit = () => {
  const payload = {
    charge: Number(billData.charge),
    folio: billData.folio,
    description: billData.description,
  };
  emit('createInvoice', payload);
  resetForm();
};

const closeModal = () => {
  emit('update:active', false);
  resetForm();
};

const resetForm = () => {
  billData.charge = '';
  billData.folio = '';
  billData.description = '';
  billData.isEdit = false;
};
</script>

<style lang="sass" scoped>
.invoice
  :deep(.card)
    .card-content
      overflow: visible
      @include until($bp-sm)
        max-height: 45vh
        overflow: scroll
      .monto-addon
        border-radius: 5px 0px 0px 5px
        background: $grey-light
        border: 1px solid $grey-light-2
        padding: 5px 10px
        color: $grey-info
</style>
